export default "__VITE_PUBLIC_ASSET__8f49f61c__"